<template>
  <div>
    <vs-input icon-no-border placeholder="Suchen ..."
              v-model="searchAll"
              icon-pack="feather"
              icon="icon-search"
              size="large"
              class="w-full mt-6"
    />
    <div class="mt-5">
      <transition-group tag="div" class="vx-row" name="trs-fade-out-fast" mode="out-in">
        <div v-for="reservation in this.$store.getters.getAllPendingReservations" :key="reservation.id"
             class="vx-col w-full lg:w-1/3 mb-base"
             v-if="pendingReservations">
          <ReservationCard v-bind:reservation="reservation"/>
        </div>
        <div v-else>
          <p>keine Daten</p>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
  import ReservationCard from "./components/ReservationCard";
  import {mapActions, mapGetters} from "vuex";

  export default {
    components: {ReservationCard},
    data() {
      return {
        searchAll: '',
        pendingReservations: [],
        activeTab: 0,

      }
    },
    mounted() {
      this.setIsLoading(true)
      this.fetchAllPendingReservations().then((reservations) => {
        this.pendingReservations = this.$store.getters.getAllPendingReservations;
      }).then(() => {
        setTimeout(() => {
          this.setIsLoading(false)
        },1000)
      })
    },
    methods: {
      ...mapActions(['fetchAllPendingReservations']),
      ...mapActions(['setIsLoading']),
      ...mapActions(['setSearchAllString']),
    },
    watch: {
      searchAll: function (value) {
        this.setSearchAllString(value)
      }
    },
    computed: {
      ...mapGetters(['getSearchAllString']),
    },
  }

</script>


